export interface Testimonial {
  name: string;
  handle: string;
  initials: string;
  color: string;
  text: string;
}

export const testimonials: Testimonial[] = [
  {
    name: "Marcus Johnson",
    handle: "@marcusfits",
    initials: "MJ",
    color: "bg-accent-100 text-accent-700",
    text: "This Pandabuy spreadsheet literally changed how I shop. Instead of scrolling for hours through random links, I just open the sheet and find exactly what I need. Saved me so much time and money.",
  },
  {
    name: "Sophie Laurent",
    handle: "@sophiestyle",
    initials: "SL",
    color: "bg-primary-100 text-primary-700",
    text: "I've tried so many Pandabuy spreadsheets before, but this one is genuinely the best. The quality ratings and price comparisons are spot on. My go-to for every fashion haul.",
  },
  {
    name: "Alex Chen",
    handle: "@alexfinds",
    initials: "AC",
    color: "bg-secondary-100 text-secondary-700",
    text: "The sneaker section alone is worth bookmarking. Found three pairs of Jordans that were all under $50 and the quality blew me away. The spreadsheet format makes everything so organized.",
  },
  {
    name: "Emma Williams",
    handle: "@emmahauls",
    initials: "EW",
    color: "bg-accent-100 text-accent-700",
    text: "Finally a Pandabuy spreadsheet that actually updates regularly! Most sheets I find are months old with dead links. This one is always fresh with new finds every week.",
  },
  {
    name: "David Park",
    handle: "@davidfashion",
    initials: "DP",
    color: "bg-primary-100 text-primary-700",
    text: "The streetwear category is insane. Found Stussy, Supreme, and Essentials pieces that look identical to retail. The shipping estimates help me plan my hauls perfectly.",
  },
  {
    name: "Isabella Rossi",
    handle: "@bellastyle",
    initials: "IR",
    color: "bg-secondary-100 text-secondary-700",
    text: "As someone new to Pandabuy, this spreadsheet was a lifesaver. The guide section explains everything clearly, and the seller reliability notes gave me confidence to place my first order.",
  },
];